(function () {
    'use strict';

    angular
        .module('questionnaireTemplatesEditModule')
        .controller('ODDQuestionnaireTemplateSectionEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$window', 'topBarService', 'businessUnit', 'questionnaireTemplate',
        'questionnaireSection', 'oddQuestionnaireTemplateService', 'modalService', 'notificationService'];

    function Controller($scope, $state, $window, topBarService, businessUnit, questionnaireTemplate, questionnaireSection,
                        questionnaireService, modalService, notificationService) {

        topBarService.setTitleAndIcon('Operational Due Diligence | ' + businessUnit.TitleEN, 'icon icon-clipboard');
        // scroll to top of the page on init.
        $window.scrollTo(0, 0);

        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.questionnaireSection = questionnaireSection;

        $scope.goToComponentListEdit = function () {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire.section.editComponentList', {
                ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                ODDQuestionnaireSectionID: questionnaireSection.ODDSectionID
            });
        };

        // Go To Questionnaire Template
        $scope.goToQuestionnaireTemplate = function (qTemplate) {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire', { ODDQuestionnaireID: qTemplate.ODDQuestionnaireID }, { reload: true });
        };

        // Go To Component
        $scope.goToComponent = function (component) {
            if (component.ODDQuestionID) {
                $state.go('odd.questionnaireTemplatesEdit.questionnaire.section.question.edit', {
                    ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                    ODDQuestionnaireSectionID: questionnaireSection.ODDSectionID,
                    ODDQuestionID: component.ODDQuestionID
                });
            }
            else if (component.ODDStaticTextID) {
                $state.go('odd.questionnaireTemplatesEdit.questionnaire.section.staticTextEdit', {
                    ODDStaticTextID: component.ODDStaticTextID
                });

            }
        };

        $scope.addPageBreak = function() {
            return questionnaireService.createPageBreak(
                    questionnaireTemplate.ODDBusinessUnitID,
                    questionnaireTemplate.ODDQuestionnaireID,
                    questionnaireSection.ODDSectionID).then(function () {

                $state.reload();
                notificationService.notify('Page Break has been created');
            });
        };

        // Add Question
        $scope.addQuestion = function () {

            // Fetch types
            questionnaireService.getQuestionTypes()
                .then(function (questionTypes) {
                    var modal = modalService.displayTemplateModal(
                        'Select a Question Type',
                        require('../../../shared/odd/questionnaireTemplate/questionType/oddQuestionType.modal.tpl.html'),
                        {
                            questionTypes: questionTypes,
                            ctrl: { step: 'questionTypes' },
                            onQuestionTypeSelection: function(ctrl, questionType) {
                                if (questionType.Code.indexOf('MultipleChoice') === 0) {
                                    ctrl.step = 'multipleChoiceTemplates';
                                    ctrl.questionType = questionType;
                                    modal.$scope.title = 'Select a ' + questionType.TitleEN + ' Template';

                                    questionnaireService.getQuestionMultiChoiceTemplates().then(function(multiChoiceTemplates) {
                                        ctrl.multiChoiceTemplates = multiChoiceTemplates;
                                    });
                                } else {
                                    modal.$promise.then(modal.hide);

                                    $state.go('odd.questionnaireTemplatesEdit.questionnaire.section.addQuestion', {
                                        ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                                        ODDQuestionnaireSectionID: questionnaireSection.ODDSectionID,
                                        ODDQuestionTypeCode: questionType.Code
                                    });
                                }
                            },
                            onUserDefinedMultiChoiceSelection: function(ctrl) {
                                modal.$promise.then(modal.hide);

                                $state.go('odd.questionnaireTemplatesEdit.questionnaire.section.addQuestion', {
                                    ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                                    ODDQuestionnaireSectionID: questionnaireSection.ODDSectionID,
                                    ODDQuestionTypeCode: ctrl.questionType.Code
                                });
                            },
                            onMultiChoiceTemplateSelection: function(ctrl, multiChoiceTemplate) {
                                modal.$promise.then(modal.hide);

                                $state.go('odd.questionnaireTemplatesEdit.questionnaire.section.addQuestionTemplate', {
                                    ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                                    ODDQuestionnaireSectionID: questionnaireSection.ODDSectionID,
                                    ODDQuestionTypeCode: ctrl.questionType.Code,
                                    ODDQuestionChoiceTemplateID: multiChoiceTemplate.ODDQuestionChoiceTemplateID
                                });
                            }
                        },
                        false
                    )
                });
        };

        // Add StaticText
        $scope.addStaticText = function () {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire.section.addStaticText', {
            });
        }
    }
})();
